// Urutan gambar bangunan (painter's algorithm iso untuk tapak persegi).
import { TILE_H } from "./iso";
import { refHeight } from "./paint";

// ---- Urutan gambar bangunan (painter's algorithm iso untuk tapak persegi) ----
// Di-cache per referensi state.buildings+defs (dihitung ulang hanya saat kota berubah,
// bukan saat pan/zoom). Hubungan "di depan" dievaluasi pada pasangan yang kotak
// layarnya bersinggungan; sisa siklus (tak lazim) ditambahkan berurutan x+y.
export function createIsoOrder() {
  let orderCache = { src: null, defs: null, order: [] };
  function isoBuildingOrder(buildings, defById, defs) {
    if (orderCache.src === buildings && orderCache.defs === defs) return orderCache.order;
    const n = buildings.length;
    const R = buildings.map(b => {
      const def = defById[b.bid];
      let w = def?.w || 1, h = def?.h || 1;
      if ((b.rot || 0) % 2 === 1) [w, h] = [h, w];
      const H = refHeight(def?.floors ?? 1, w, h, 1) / (TILE_H / 2); // tinggi dalam satuan hh (zoom 1)
      return { x0: b.x, y0: b.y, x1: b.x + w, y1: b.y + h, sum: b.x + b.y,
        sx0: b.x - (b.y + h), sx1: (b.x + w) - b.y, sy0: (b.x + b.y) - H, sy1: (b.x + w) + (b.y + h) };
    });
    const adj = Array.from({ length: n }, () => []), indeg = Array.from({ length: n }, () => 0);
    const front = (B, A) => B.x0 >= A.x1 || B.y0 >= A.y1; // B di depan A?
    for (let i = 0; i < n; i++) {
      const a = R[i];
      for (let j = i + 1; j < n; j++) {
        const b = R[j];
        if (a.sx1 <= b.sx0 || b.sx1 <= a.sx0 || a.sy1 <= b.sy0 || b.sy1 <= a.sy0) continue; // tak bersinggungan di layar
        const fb = front(b, a), fa = front(a, b);
        let first = i, second = j; // default: i digambar dulu
        if (fa && !fb) { first = j; second = i; }
        else if (fa === fb && b.sum < a.sum) { first = j; second = i; }
        adj[first].push(second); indeg[second]++;
      }
    }
    // Kahn dengan prioritas x+y terkecil
    const ready = [];
    for (let i = 0; i < n; i++) if (!indeg[i]) ready.push(i);
    const byDepth = (p, q) => R[p].sum - R[q].sum || R[p].x0 - R[q].x0;
    ready.sort(byDepth);
    const order = [];
    while (ready.length) {
      const i = ready.shift();
      order.push(buildings[i]);
      let added = false;
      for (const j of adj[i]) if (--indeg[j] === 0) { ready.push(j); added = true; }
      if (added) ready.sort(byDepth);
    }
    if (order.length < n) { // siklus: tambahkan sisanya berurutan kedalaman
      const seen = new Set(order);
      buildings.map((b, i) => i).filter(i => !seen.has(buildings[i])).sort(byDepth).forEach(i => order.push(buildings[i]));
    }
    orderCache = { src: buildings, defs, order };
    return order;
  }
  return isoBuildingOrder;
}
